export const informationFieldCategories = [
    {
        id: "CONTACT_NUMBER",
        value: "ContactNumber",
    },
    {
        id: "EMAIL",
        value: "Email",
    },
    {
        id: "ADDRESS",
        value: "Address",
    },
    {
        id: "OTHER",
        value: "Other",
    },
];